import { useContext } from "react";
import { VendorThemeContext } from "contexts/vendorContext";
import styled from "@emotion/styled";
import { breakpoints } from "styles/utils";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  @media (min-width: ${breakpoints.large}) {
    display: grid;
    grid-template-columns: max-content 1fr;
    align-items: center;
    gap: 28px;
  }
`;

const LogoVendorName = styled.img`
  max-width: 100%;
  height: auto;
  display: block;
  height: 50px;
`;

const VendorHero = () => {
  const { vendorTheme } = useContext(VendorThemeContext);
  return (
    <Container>
      <LogoVendorName
        loading="lazy"
        alt="logo com o nome do provedor"
        src={vendorTheme?.vendorTitleImage}
      />
    </Container>
  );
};
export default VendorHero;
